import { render, staticRenderFns } from "./fund.vue?vue&type=template&id=4b1b8cc0"
import script from "./fund.vue?vue&type=script&setup=true&lang=js"
export * from "./fund.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports